import environmentReducer from '../environmentsReducer';
import undoable, { includeAction } from 'redux-undo';
import * as environmentsUndoableActionTypes from '../../EnvironmentsUndoableActionTypes';

const undoableEnvironmentsReducer = undoable(environmentReducer, {
  filter: includeAction(Object.keys(environmentsUndoableActionTypes)),
});

export default undoableEnvironmentsReducer;
